import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { useIdentity } from '@internal/shared';
import { useEffect } from 'react';

export const IdToken = ({
  onChange
}: FieldExtensionComponentProps<string>) => {
  const res = useIdentity();

  useEffect(() => {
    if (res.idToken) {
      onChange(res.idToken);
    }
  }, [res.idToken, onChange]);

  return null;
};